import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VideosSection } from './components/VideosSection';
import { GuitarAcademy } from './components/GuitarAcademy';
import { Footer } from './components/Footer';

export const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState('home');

  const scrollToSection = (id: string) => {
    setActiveTab(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#FFF5F8] text-[#4A3E4D]">
      {/* Top Kawaii Bar */}
      <div className="bg-gradient-to-r from-pink-400 via-purple-400 to-rose-400 text-white text-[11px] sm:text-xs py-1.5 px-4 text-center font-bold tracking-wide flex items-center justify-center gap-2">
        <span>✨ Welcome to melodalis.com — Watch "Petty (Freya Skye Tribute)" & Learn Guitar! 🎸</span>
      </div>

      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <main className="flex-1">
        <Hero
          onExploreVideos={() => scrollToSection('videos')}
          onExploreGuitar={() => scrollToSection('guitar')}
        />

        <VideosSection />

        <GuitarAcademy />
      </main>

      <Footer />
    </div>
  );
};

export default App;

